import cx from 'classnames'

import { Card } from '../Card/Card'

export const FormCard = ({ children, className, description, title, ...props }) => (
  <Card className={className} {...props}>
    <div className="tw:p-5 tw:mobile:p-4">
      {title && <h2 className="ds-heading-4">{title}</h2>}
      {description && <p className="ds-helper tw:mt-1">{description}</p>}
      <div className={cx((title || description) && 'tw:mt-5')}>{children}</div>
    </div>
  </Card>
)
